import styled from 'styled-components';

import GrayContainer from 'styles/buttons/GrayContainer';

export default styled(GrayContainer)`
  height: 50px;
  padding-left: 20px;
  padding-right: 20px;
`;
